import {types} from '../actions/types';

const initialState = {
  loading: false,
  data: {},
  error: {},
};

const getMyBackrrsReducer = (state = initialState, {type, payload}) => {
  switch (type) {
    case types.SEND_REQUEST_GET_MY_BACKRRS:
      return {
        ...state,
        loading: true,
      };
    case types.SEND_REQUEST_GET_MY_BACKRRS_SUCCESS:
      return {
        ...state,
        data: payload,
        loading: false,
      };
    case types.SEND_REQUEST_GET_MY_BACKRRS_FAILURE:
      return {
        ...state,
        data: {},
        error: payload,
        loading: false,
      };
      case types.CLEAR_REQUEST_GET_MY_BACKRRS:
        return {
          ...state,
          data: {},
          loading: false,
        };
    default:
      return state;
  }
};

export default getMyBackrrsReducer;
